export const PURCHASE_ORDER_ROUTE = "/purchase-order";
export const PURCHASE_ORDER_APPROVAL_ROUTE = "/approvals/purchase-order";
